import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import ru from './locales/ru.json';

/** Languages the interface is translated into; the first is the fallback. */
export const supportedLanguages = ['ru', 'en'] as const;

export type Language = (typeof supportedLanguages)[number];

/** Storage key that remembers an explicit choice of language. */
export const languageStorageKey = 'nazubke.language';

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { ru: { translation: ru }, en: { translation: en } },
    supportedLngs: supportedLanguages,
    fallbackLng: 'ru',
    nonExplicitSupportedLngs: true,
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: languageStorageKey,
      caches: ['localStorage'],
    },
    initAsync: false,
  });

/** Normalises a detected language such as "en-US" to a supported one. */
export function currentLanguage(): Language {
  const base = i18n.resolvedLanguage ?? i18n.language;

  return supportedLanguages.find((language) => base.startsWith(language)) ?? 'ru';
}

export { i18n };
